import {
  Breadcrumbs,
  BreadcrumbsProps,
} from '@virginexperiencedays/components-v2/src/navigation/Breadcrumbs';

const Component = (props: BreadcrumbsProps) => <Breadcrumbs className="my-4 md:my-6" {...props} />;

export default Component;
